import axiosInstance from './axiosInstance';

export const getActiveBuddies = (userId) =>
    axiosInstance.get(`/UserBuddy/user/${userId}`).then(r => r.data);

export const getBuddyHistory = (userId) =>
    axiosInstance.get(`/UserBuddy/user/${userId}/history`).then(r => r.data);

export const getAllActiveBuddies = () =>
    axiosInstance.get('/UserBuddy/all-active').then(r => r.data);

export const saveBuddies = (body) =>
    axiosInstance.post('/UserBuddy/save', body).then(r => r.data);
